import { getOrgID, getUri, patchUri, postUri } from '../utils/fetch';
import Env from '../utils/env';
import { IConfig } from '@rhc-shared-components/control-wrapper';
import { IProjectRhcertStatus } from "../interfaces/projectRhcert";

// GETs the Onboarding Status
export const getOnboardingStatus = (): Promise<any> => {
  const uri = Env.hydraAPIURL
    .clone()
    .setPath(`${Env.hydraAPIPrefix}/companies/current/onboarding/status`);
  return getUri(uri);
};

// Request to sell on marketplace
// Builds request data
const assignData = (objectToAssign, cookie, cookieKey, objectKey) => {
  if (cookie[cookieKey]) {
    Object.assign(objectToAssign, { [objectKey]: cookie[cookieKey] });
  }
  return objectToAssign;
};

export const sellOnMarketplace = (
  rhpcProjectId: string,
  projectName: string
): Promise<any> => {
  let data = {};
  // phone, company is optional
  const userData = window?.sessionjs?.getuserInfo();
  data = assignData(data, userData, 'firstName', 'fname');
  data = assignData(data, userData, 'lastName', 'lname');
  data = assignData(data, userData, 'email', 'email');
  data = assignData(data, userData, 'organization_id', 'rhpcVendorId');
  Object.assign(data, {
    rhpcProjectId,
    product: projectName,
    channel: 'REDHAT',
    rhpcVendorId: getOrgID(),
  });
  const uri = Env.hydraProxyURL
    .clone()
    .setPath(`${Env.hydraProxyPrefix}/omNomination/create`);
  return postUri(uri, data);
};

//Creates the RHEL or OpenStack non container project
export const createPfsNonContainerProject = (payload): Promise<any> => {
  const uri = `${Env.ConnectPortalUrls[Env.getEnvName()]}${Env.pfsNonContainerPrefix}`;
  return postUri(uri, payload);
};

//Patches the RHEL or OpenStack Non Container Project
export const updatePfsNonContainerProject = (pyxisId, payload): Promise<any> => {
  const uri = `${Env.ConnectPortalUrls[Env.getEnvName()]}${Env.pfsNonContainerPrefix}/pyxis-id/${pyxisId}`;
  return patchUri(uri, payload);
}

// GETs the config values
export const getCwfConfig = (): Promise<IConfig[]> => {
  const uri = Env.hydraProxyURL
    .clone()
    .setPath(`${Env.hydraRestPrefix}/cwf_config`);
  return getUri(uri);
}
export const getProjectRhcertCase = (projectId, abortSignal?: AbortSignal): Promise<IProjectRhcertStatus> => {
  const uri = Env.hydraProxyURL.clone().setPath(`${Env.hydraCwePrefix}/${projectId}/certification`);
  const params = abortSignal ? { "signal": abortSignal } : {};
  return getUri(uri, params);
}

export const createProjectRhcertCase = (projectId): Promise<any> => {
  const uri = Env.hydraProxyURL.clone().setPath(`${Env.hydraCwePrefix}/certifications`);
  return postUri(uri, projectId);
};

